import { connect } from "react-redux";

import * as autoinvestActions from "./actions";

function mapStateToProps(state) {
  return {
    autoinvest: state.autoinvest,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAutoinvestStatus: () => {
      dispatch(autoinvestActions.get_auto_invest_status());
    },

    switchAutoinvestStatus: (currentValue) => {
      dispatch(autoinvestActions.switch_auto_invest(currentValue));
    },
  };
}

export const autoInvestConnector = connect(mapStateToProps, mapDispatchToProps);
